// Engelske tekster for nøkler som tidligere bare hadde norsk fallback i
// koden (PRD US23, pakke P16-11). Slås sammen med englishCrmMessages i
// i18nProvider. i18nCoverage.test.ts sjekker at hver nøkkel koden bruker
// finnes på engelsk.
export const englishExtraMessages = {
  crm: {
    actions: {
      more: "More actions",
    },
    brreg: {
      filled:
        "Fetched from the Brønnøysund register. Check the fields and save.",
      invalid_orgnr: "Enter a valid org. no. (9 digits) first.",
      lookup: "Fetch from BRREG",
    },
    bulk: {
      archive_partial:
        "%{ok} of %{total} were archived. The others are selected again. Reason: %{reason}",
      delete_confirm: "Delete %{smart_count} |||| Delete %{smart_count}",
      delete_description: "The deletion cannot be undone.",
      delete_title:
        "Delete %{smart_count} record? |||| Delete %{smart_count} records?",
      more_failed: "and %{smart_count} more",
      partial_description:
        "%{smart_count} failed. The others are saved and stay as they are. |||| %{smart_count} failed. The others are saved and stay as they are.",
      partial_title: "%{ok} of %{total} were saved",
      retry_failed:
        "Retry %{smart_count} failed |||| Retry %{smart_count} failed",
      scope_all:
        "%{smart_count} selected (all results) |||| All %{smart_count} results are selected",
      scope_page:
        "%{smart_count} selected on this page |||| %{smart_count} selected on this page",
      scope_pages:
        "%{smart_count} selected, including on other pages |||| %{smart_count} selected, including on other pages",
    },
    command: {
      action: {
        create: "Create",
        go: "Go to",
        open: "Open",
      },
      ask: {
        aborted: "Aborted",
        back: "Back to search",
        empty:
          "Customers, tasks, projects, email and notes. Claude reads but changes nothing.",
        empty_title: "Ask about anything in Mimin",
        fallback: "Ask Claude about «%{q}»",
        hint: "Ask Claude",
        label: "Ask Claude",
        new: "New conversation",
        new_chat: "New conversation",
        no_answer: "Couldn't find an answer to that.",
        placeholder: "Ask Claude about anything in Mimin …",
        retry: "Try again",
        send: "Send",
        stop: "Stop response",
      },
      create: "Create",
      description: "Search for a command to run ...",
      emails: "Email campaigns",
      empty_for: "No results for «%{q}»",
      footer: {
        close: "Close",
        navigate: "Select",
      },
      kind: {
        action: "Action",
        company: "Customer",
        contact: "Contact",
        deal: "Opportunity",
        email: "Email campaign",
        note: "Note",
        page: "Page",
        project: "Project",
        prospect: "Prospect",
        work_item: "Task",
      },
      navigate: "Go to",
      notes: "Notes",
      placeholder: "Search or navigate...",
      recent: "Recent",
      search: "Search",
      searching: "Searching …",
      title: "Command palette",
    },
    companies: {
      load_error: "Could not load customers. Your filters have been kept.",
    },
    company_emails: {
      empty: "No email campaigns.",
      sent_count: "%{smart_count} sent",
      title: "Email",
    },
    company_notes: {
      add: "Add note",
      complete_follow_up: "Complete follow-up",
      follow_up_complete_failed:
        "Could not complete the follow-up. It is still in To do.",
      follow_up_completed: "Follow-up completed",
      empty: "No notes yet.",
      follow_up: "Follow-up",
      overdue: "overdue",
      placeholder: "Write a note ...",
      title: "Notes",
    },
    company_products: {
      add: "Add product",
      cost_fallback: "Empty = product's purchase price",
      edit: "Edit product",
      empty: "No products yet.",
      per_month: "per month",
      price_fallback: "Empty = product's sales price",
      price_overridden: "Agreed price (overrides the product price)",
      remove: "Remove product",
      remove_confirm:
        "Remove the product from this customer? The product itself stays in the catalog.",
      title: "Products",
      totals: {
        cost: "Cost",
        margin: "Margin",
        monthly: "Per month",
        one_time: "One-time",
        price: "Price",
        yearly: "Per year",
      },
    },
    company_tasks: {
      none: "No open tasks",
      open: "Open tasks",
      overdue: "Overdue %{date}",
      see_all: "See all %{smart_count}",
    },
    custom_fields: {
      active_filters: "Active filters",
      add_filter: "Filter by field",
      apply_filter: "Apply filter",
      choose_field: "Choose field …",
      choose_value: "Choose value …",
      field: "Field",
      hidden_suffix: "(hidden)",
      list_tools: "Custom fields",
      manage: "Custom fields",
      operator: "Comparison",
      remove_filter: "Remove filter",
      save: "Save fields",
      sort_by: "Sort by",
      sort_label: "custom field",
      title: "Custom fields",
      value: "Value",
    },
    customer: {
      color: "Color",
      info_tab: "Customer info",
    },
    dashboard: {
      drift: {
        title: "Maintenance radar",
      },
      first_actions: {
        admin_customer: "Register your first customer",
        admin_invoice_basis: "See this month's invoice basis",
        admin_user: "Add an employee",
        done: "(done)",
        hide: "Hide Get started",
        log_contact: "Log a contact on a customer",
        my_tasks: "See your tasks",
        subtitle: "Three things to do first in Mimin.",
        title: "Get started",
        tutorial: "Take the tutorial",
      },
      kpi: {
        active_projects: "Active projects",
        due_this_week: "Due this week",
        hours_this_week: "Hours this week",
        overdue_tasks: "Overdue tasks",
      },
      radar: {
        empty: "All customers have been contacted in the last 90 days.",
        never: "Never contacted",
        overdue_deals: "Overdue next steps (opportunities)",
        title: "Needs follow-up",
      },
      shared_note: {
        last_edited: "Last edited by",
      },
      today: {
        complete_follow_up_named: "Complete follow-up: %{name}",
        due_today: "Today",
        empty: "Nothing open. You're all caught up.",
        empty_mine: "Nothing open for you. Choose Team to see the rest.",
        empty_unowned: "Nothing open without an owner.",
        mine: "Mine",
        scope: "Show to-dos for",
        see_all: "See all",
        team: "Team",
        title: "To do",
        unowned: "Unowned",
      },
      widget: {
        default_1: "Shared notes",
        default_2: "Useful links",
        empty: "Empty widget. Click to write.",
        placeholder:
          "Write something the whole team can see. Feel free to paste images …",
        rename: "Name the widget",
      },
    },
    deals: {
      capped:
        "Showing %{shown} of %{total} opportunities. Use the filters to narrow down.",
      card: {
        move: "Move %{name}",
        move_to: "Move to",
        no_next_step: "No next step",
        overdue: "Overdue",
      },
      clear_filters: "Clear filters",
      count: "%{smart_count} opportunities",
      list_empty: "No opportunities found.",
      load_error: "Could not load opportunities. Your filters have been kept.",
      loss_dialog: {
        choose: "Choose reason",
        optional: "Optional, but it helps the report.",
        skip: "Skip",
        title: "Why did we lose the opportunity?",
      },
      loss_prompt: "Why did we lose this one?",
      no_matches: "No opportunities match the filters.",
      projects: {
        choose: "Choose project",
        create_another: "Create another project",
        label: "Project |||| Projects",
        link: "Link project",
        link_description:
          "Choose one of the customer's projects that doesn't already come from an opportunity.",
        link_save: "Link",
        none_free:
          "The customer has no projects to link. Create a new one instead.",
        open: "Project",
        open_named: "Open %{name}",
      },
      view_kanban: "Board",
      view_list: "List",
      weighted: "Weighted",
    },
    dialog: {
      active: "Active",
      ask_review_no_effect: "Has no effect when «Has review» is on",
      ask_review_short: "Ask",
      col_company: "Customer",
      col_date: "Date",
      col_interest: "Interest",
      col_nps: "Recommendation",
      col_score: "Smiley",
      confirm_remind_content:
        "The template «%{navn}» will be sent to %{smart_count} customers who have not replied, to the address in the list.",
      confirm_remind_title: "Send reminder?",
      confirm_send_content:
        "The template «%{navn}» will be sent to %{smart_count} customers, to the address in the list, each with their own link.",
      confirm_send_title: "Send the invitation?",
      copy_link: "Copy link",
      drag: "Drag to move",
      edit_question: "Edit question",
      editor_help:
        "Changes appear on the Dialog page on next load. Responses already submitted keep their own questions.",
      f_conditions: "Only shown when (all must be met)",
      f_exclusive: "Exclusive option (clears the others)",
      f_intro: "Intro (line above the title)",
      f_key: "Key",
      f_label: "Short name in the letter",
      f_left: "Left label",
      f_max: "Max",
      f_min: "Min",
      f_options: "Options, one per line",
      f_placeholder: "Placeholder in the text field",
      f_required: "Required",
      f_right: "Right label",
      f_section: "Section",
      f_subtitle: "Subtitle",
      f_title: "Title",
      f_type: "Type",
      followup: "Follow-up",
      followup_create: "Create follow-up task",
      followup_created: "The follow-up task has been created.",
      followup_done: "completed",
      followup_due: "Due date",
      followup_exists: "Follow-up exists:",
      followup_owner: "Owner",
      generate_links: "Generate links",
      has_review_short: "Has review",
      help: "The customer survey at dialog.digitelle.no: edit the questions, send links to customers and read the responses.",
      interest_list: "Wants to hear more about",
      invalid_email: "Invalid email address",
      invitation_template: "Invitation template",
      key_locked:
        "The key cannot be changed: humor, anbefale, interesse, naar and anmeldelse drive alerts and tasks.",
      kpi_ces: "Avg. ease (1–7)",
      kpi_count: "Responses",
      kpi_nps: "NPS",
      kpi_nps_basis:
        "%{n} responses (%{periode}) · %{promotorer} promoters, %{passive} passives, %{kritikere} detractors",
      kpi_score: "Avg. smiley (1–5)",
      link_copied: "Link copied",
      links_created: "Created %{smart_count} links",
      new_question: "New question",
      no_email: "No address",
      no_interest: "No one has ticked anything yet.",
      no_invitations:
        "No links created yet. Choose customers and click «Generate links».",
      no_recipient_email:
        "None of the customers have an email address. Fill in the address in the list first.",
      no_survey:
        "No active survey. Run the migration that seeds «Kundeundersøkelse 2026».",
      no_template:
        "Choose a template with the {dialoglenke} merge field first.",
      none_yet: "No responses yet.",
      open_company: "Open customer",
      period: "Period",
      pick_companies: "Customers",
      pick_help:
        "The email goes to the address in the list (the customer's main address); if you change it, it is saved on the customer. «Has review» and «Ask» control whether the customer gets the question about a Google review. Customers who already have an unanswered link are skipped.",
      question_saved: "Question saved",
      questions_empty: "No questions yet.",
      questions_help:
        "Drag to reorder. Turn a question off instead of deleting it, so old responses keep their meaning. Preview: dialog.digitelle.no/?demo=1.",
      recipient_email: "Recipient address",
      recipient_email_help:
        "The customer's main address. Changes are saved on the customer.",
      reminder_help:
        "To everyone who got the link more than 7 days ago, has not replied and has not been reminded before.",
      reminder_template: "Reminder template",
      responses_empty:
        "No responses yet. They show up here when customers submit.",
      save_failed: "Could not save.",
      send_help:
        "Goes to the selected customers who have an unanswered link, one email per customer to the address in the list, with the customer's link in {dialoglenke}.",
      send_invitations: "Send invitation to %{smart_count} selected",
      send_reminders: "Send reminder (%{smart_count})",
      skipped_no_email:
        "%{smart_count} customers without an email address were skipped",
      smiley_hint:
        "Five options from worst to best. Score 1–5 is the position in the list.",
      status_title: "Status per recipient",
      tab_invitations: "Send-outs",
      tab_questions: "Questions",
      tab_responses: "Responses",
      template_missing_link:
        "The template is missing the {dialoglenke} merge field.",
      top_praise: "Top three «appreciated»",
      unknown_company: "Unknown customer",
    },
    drift: {
      accessibility: "Accessibility",
      deep_scanned: "Deep scan complete.",
      deep_scanned_at: "Deep scan",
      empty:
        "Not scanned yet. Run a scan to see maintenance and upsell findings for the customer's website.",
      findings: "Findings",
      help: "The findings are improvement points for the customer's website: proactive maintenance and natural upsell conversations.",
      last_scanned: "Last scanned",
      no_findings: "No findings. The website looks good.",
      no_orgnr:
        "Add an organization number to the customer to scan their website.",
      no_site: "No website to scan.",
      performance: "Performance",
      report: {
        findings: "Findings",
        findings_sub: "improvement points",
        footer:
          "Basis: an automated analysis of the organization's website. The findings are indicative and should be verified manually.",
        no_findings: "No findings. The website looked good at the last scan.",
        no_scan:
          "Not scanned yet. Run a scan from the Maintenance tab on the customer card first.",
        not_found: "Customer not found.",
        title: "Website health report",
      },
      report_button: "Report",
      scan_deep: "Deep scan (Lighthouse)",
      scan_light: "Scan website",
      scanned: "The website has been scanned.",
      seo: "Technical SEO",
      title: "Maintenance",
    },
    email: {
      add_group: "Add group",
      back_to_groups: "Back to groups",
      back_to_sent: "Back to sent",
      back_to_templates: "Back to templates",
      body: "Message",
      body_placeholder_rich: "Hi {fornavn}, …",
      bounced_label: "Bounced",
      clear_filters: "Clear",
      companies_in_group: "Customers in the group",
      compose: "New email",
      compose_help:
        "Write a simple message and choose which customers it goes to. Each contact person, and the customer's own email field, gets their own email.",
      confirm_content:
        "The email will be sent to ~%{estimate} recipients at %{companies} customers. This cannot be undone.",
      confirm_recipients:
        "The email will be sent to %{recipients} recipients at %{companies} customers. This cannot be undone.",
      confirm_title: "Send email?",
      count_summary: "%{companies} customers · ~%{recipients} recipients",
      date_from: "From date",
      date_to: "To date",
      delete_group_content:
        "The group will be removed. Customers and emails are not affected.",
      delete_group_title: "Delete the group?",
      delete_template_content:
        "The template will be removed. Emails already sent are not affected.",
      delete_template_title: "Delete the template?",
      delivered_label: "Delivered",
      dialog_title: "Dialog",
      edit_group: "Edit group",
      edit_template: "Edit template",
      error: "Could not send email",
      excluded_title: "Won't receive the email (%{count})",
      failed_label: "Failed",
      filter_sector: "Industry",
      group_deleted: "Group deleted",
      group_dynamic: "Dynamic",
      group_dynamic_help:
        "Recipients are calculated from the filter every time you send, so new matching customers are included automatically. No selection = all active customers.",
      group_dynamic_title:
        "Dynamic group. Recipients are calculated from the filter now",
      group_manual: "Manual",
      group_name: "Group name",
      group_name_placeholder: "E.g. Active customers",
      group_saved: "Group saved",
      group_type: "Type",
      groups_empty:
        "No groups yet. Create one to send to the same customers again.",
      groups_help: "Saved groups of customers you can choose as recipients.",
      groups_title: "Groups",
      matching_companies: "Customers matching now",
      merge_hint:
        "Merge fields you can use: {fornavn} (first name), {etternavn} (last name), {navn} (full name).",
      message: "Message",
      n_companies: "%{smart_count} customers",
      new_group: "New group",
      new_template: "New template",
      next_page: "Next",
      no_companies: "No customers found",
      no_hits: "No email campaigns matched the search.",
      no_matching_companies: "No customers match the filter.",
      no_subject: "(no subject)",
      not_found: "Email not found.",
      optout_label: "Unsubscribed (skipped)",
      pagination_range: "Showing %{from}–%{to} of %{total}",
      pick_template: "Choose a template …",
      prev_page: "Previous",
      preview: "Preview",
      preview_desc:
        "Example with recipient «%{navn}». Merge fields are filled in per recipient when sending.",
      preview_title: "Preview",
      recipients: "Recipients",
      recipients_all: "All",
      recipients_failed:
        "Could not load the recipient list (%{message}). Unsubscribed addresses are filtered out when sending regardless.",
      recipients_list: "Recipients (%{count})",
      recipients_loading: "Loading recipients …",
      recipients_title: "Recipients",
      reply_to: "replies go to",
      save_as_template: "Save as template",
      save_template_desc:
        "The subject and message are saved as a template you can reuse in «New email».",
      search_companies: "Search customers",
      search_placeholder: "Search subject and content …",
      send: "Send email",
      send_test: "Send test to me",
      send_to: "Send to %{count} recipients",
      sends_from: "Sent from",
      sent: "Sent %{smart_count} emails",
      sent_at: "Sent %{date}",
      sent_empty: "No sent emails yet.",
      sent_label: "Sent",
      sent_title: "Sent emails",
      sent_with_failures: "Sent %{smart_count} emails (%{failed} failed)",
      subject: "Subject",
      subject_placeholder: "Email subject",
      suppression_hint:
        "Unsubscribed addresses are excluded from the count and skipped when sending. Bounced addresses are left out by Mailgun.",
      template_deleted: "Template deleted",
      template_name: "Template name",
      template_name_placeholder: "E.g. Newsletter",
      template_saved: "Template saved",
      templates_empty:
        "No templates yet. Save one from «New email», or create one here.",
      templates_help:
        "Saved templates (subject and message) you can reuse in «New email».",
      templates_title: "Templates",
      test_sent: "Test message sent to %{to}",
      title_page: "Email",
      to_companies: "Sent to customers",
      unsubscribe_hint:
        "An unsubscribe link is automatically added at the bottom of each email (Norwegian Marketing Control Act § 15).",
      use_template: "Use template",
    },
    error_log: {
      all: "All",
      empty: "No errors recorded.",
      help: "Errors from the last %{days} days. The user sees the reference (F-…) in the error message; search for it here. Only a short, sanitized error text is stored.",
      unavailable: "The error log can't be read right now.",
      network: "Network",
      validation: "Validation",
      access: "Access",
      billing: "Unclear invoice outcome",
      unknown: "Other",
    },
    field_defs: {
      change: {
        choose: "Choose …",
        clear: "Clear the value",
        clear_rest: "Clear the rest",
        clear_short: "Clear",
        confirm: "Save the change",
        count: "%{smart_count} record |||| %{smart_count} records",
        description:
          "Choose what should happen to each value before the change is saved. Nothing changes until you save.",
        more: "and %{smart_count} more",
        new_value: "New value",
        saved_with_values:
          "The field is saved. %{mapped} values moved, %{cleared} cleared.",
        title:
          "%{smart_count} record has a value that doesn't fit |||| %{smart_count} records have values that don't fit",
        will_clear: "The value is removed from the records",
      },
      delete: {
        confirm_with_values: "Delete the field and its values",
        hide: "Hide instead",
        hide_hint:
          "If you only want the field gone from the forms, you can hide it. The values are then kept.",
        no_values: "No records have a value in the field.",
        title: "Delete the field «%{name}»?",
        with_values:
          "%{smart_count} record has a value in the field. Deleting removes the value permanently. |||| %{smart_count} records have a value in the field. Deleting removes the values permanently.",
      },
    },
    filter_rail: {
      bredde: "Resize the filter column",
      bredde_hint: "Drag to resize. Double-click to reset.",
    },
    filters: {
      clear: "Clear",
      due_all: "All due dates",
      due_none: "No due date",
      due_overdue: "Overdue",
      due_week: "This week",
      no_matches: "No tasks match the filter.",
      search: "Search tasks",
      unassigned: "Unassigned",
    },
    invoice_basis: {
      show_entries: "Show the time entries",
      entries_description:
        "The time entries behind this line. Open the task to change an entry.",
      entries_empty: "No time entries left on this line.",
      open_task: "Open the task",
      delete_entry: "Delete time entry",
      delete_entry_title: "Delete the time entry?",
      delete_entry_content:
        "The entry is removed from the task and the invoice basis. This cannot be undone.",
      entry_deleted: "The time entry was deleted",
      actual: "actual %{duration}",
      already_invoiced:
        "%{smart_count} time entries in the period are already invoiced",
      before_journal_start:
        "Before the first journal month (%{month}): recurring agreements count as invoiced and are not included. Hours and one-time products cannot be sent to Tripletex, but you can use «Mark as invoiced» for what is already invoiced.",
      blocked: "Issues must be fixed",
      bulk_content:
        "Creates invoice drafts in Tripletex for %{smart_count} customers (%{sum}). Each customer gets their own export in the journal with its own outcome.",
      bulk_result_summary: "%{ok} created, %{failed} failed.",
      bulk_result_title: "Invoice drafts created",
      bulk_running: "Creating … (%{done}/%{total})",
      bulk_select: "Include in bulk creation",
      bulk_send: "Create invoice drafts (%{count})",
      bulk_title: "Create invoice drafts in Tripletex?",
      csv: {
        actual_hours: "Actual time (h)",
        amount: "Amount",
        customer_number: "Customer no.",
        description: "Description",
        issue: "Issue",
        price: "Price",
        quantity: "Billable quantity",
        type: "Type",
        unit: "Unit",
        vat: "VAT %",
      },
      custom_not_sendable:
        "Custom period. Cannot be sent. Choose a whole month to send to Tripletex.",
      custom_period: "Custom period",
      empty: "No uninvoiced lines in the period.",
      free: "Free",
      incomplete: "Incomplete basis. Cannot be sent",
      internal_entries:
        "%{smart_count} time entries on your own company are internal work and are not invoiced.",
      journal: {
        actor: "Sent by",
        all_months: "All months",
        correct: "Correct",
        correct_confirm: "Correct and release the lines",
        correct_help:
          "The export of %{total} stays in the journal as corrected, with your reason. The lines are released so you can fix the basis and send it again. The new export points to this one.",
        correct_note: "Why is the export being corrected?",
        correct_title: "Correct export #%{id} for %{name}",
        correct_tripletex:
          "Mimin does not change Tripletex. Credit or delete order %{number} in Tripletex yourself before sending again.",
        corrected: "The export is corrected. The lines can be sent again.",
        corrected_by: "Corrected %{date} by %{name}",
        corrects: "Correction of export #%{id}",
        empty: "No exports match the filter.",
        export_ref: "Export #%{id} · basis %{version}",
        lines: "%{smart_count} line |||| %{smart_count} lines",
        manual: "Marked manually",
        note: "Reason",
        open_elsewhere:
          "%{smart_count} export in other months must be resolved. |||| %{smart_count} exports in other months must be resolved.",
        order: "Tripletex order %{number}",
        order_id: "Order ID in Tripletex",
        reference: "Reference",
        resolve: "Resolve",
        resolve_confirm: "Save resolution",
        resolve_created: "The draft exists in Tripletex",
        resolve_failed: "No draft in Tripletex. Release the lines",
        resolve_help:
          "Look for a draft order in Tripletex for the customer with order date %{date} and amount %{total} excl. VAT. Do not send again until this is resolved.",
        resolve_title: "Resolve the export for %{name}",
        resolved: "The export has been resolved.",
        search: "Search by customer name",
        show_open: "Show unresolved",
        status: "Status",
        status_all: "All",
        status_corrected: "Corrected",
        status_created: "Created",
        status_failed: "Failed",
        status_open: "Unresolved",
        status_sending: "Sending",
        status_unresolved: "Needs resolving",
        title: "Billing journal for the month",
        title_all: "Billing journal",
      },
      journal_inactive:
        "The billing journal is not activated. Set the first journal month under Settings → Billing.",
      journal_only: "Journal only",
      load_failed: "The invoice basis could not be loaded.",
      lost_response: "%{message} Check the journal below before trying again.",
      manual_note: "Why was this invoiced outside Tripletex?",
      manual_reference: "External reference (optional)",
      manual_reference_placeholder: "E.g. invoice number",
      mark_invoiced: "Mark as invoiced",
      mark_invoiced_content:
        "No draft is created in Tripletex. The lines for %{name} are recorded in the billing journal as manually invoiced and cannot be sent again. Only use this when the invoice has actually been created outside Mimin.",
      mark_invoiced_title: "Mark as invoiced?",
      missing_link: "Missing Tripletex link",
      missing_rate: "Missing rate",
      next_month: "Next month",
      open_sync: "Check match and sync",
      period_kind: "Period type",
      previous_month: "Previous month",
      previous_quantity:
        "Late entry: %{quantity} %{unit} was already sent earlier in the month; the quantity is the difference after rounding the total.",
      running_entries:
        "%{smart_count} timers are still running and are not included until they are stopped.",
      settings_summary:
        "Hours are rounded up to the nearest %{unit} min per line · VAT on hours %{vat} %",
      skipped:
        "%{count} uninvoiced time entries have no customer and are not included in the basis. Find their tasks and set a customer.",
      total: "Total basis (excl. VAT)",
      tripletex_content:
        "The server recalculates the basis for %{name}, reserves the lines in the journal and sends them to Tripletex as a draft order you invoice from there. If the outcome is unclear, the export must be resolved in the journal before sending again.",
      tripletex_send: "Invoice draft in Tripletex",
      tripletex_title: "Create invoice draft in Tripletex?",
      type_hours: "Hours",
      type_one_time: "One-time",
      type_recurring: "Product",
      unknown: "Unknown",
      whole_month: "Whole month",
    },
    kjenner: {
      already_customer: "Already in the customer list",
      customer_number: "Customer no.",
      hint: "Highlight a customer or prospect in the results to see context.",
      last_email: "Latest email campaign",
      last_note: "Latest note",
      manager: "Account manager",
      no_contacts: "No contacts",
      no_deals: "No open opportunities",
      no_emails: "No email campaigns received",
      no_notes: "No notes",
      not_customer: "Not in the customer list",
      open_deals: "Open opportunities",
      prospect_hint:
        "No customer with this org. no. Open the result to see the prospect.",
      title: "Do we know them?",
    },
    list: {
      add_subtask: "New subtask",
      assignee: "Assignee",
      clear_due_date: "Clear due date",
      clear_filters: "Clear filters",
      column_contacts: "Contacts",
      column_created: "Created",
      column_deals: "Opportunities",
      column_last_activity: "Last activity",
      column_last_contact: "Last contact",
      column_name: "Name",
      column_open_tasks: "Open tasks",
      column_status: "Status",
      column_tags: "Tags",
      due_date: "Due date",
      estimate: "Estimate",
      estimate_hours: "Estimate, hours",
      estimate_minutes: "Estimate, minutes",
      no_hits: "No results with the current filters",
      no_hits_for: "No results for «%{q}»",
      priority: "Priority",
      resize_column: "Resize column",
      search_global: "Search everywhere",
      show_completed: "Show completed",
      sum: "Total",
      sum_page: "Total this page",
      timer: "Timer",
      tracked: "Tracked time",
      tracked_hours: "Tracked time, hours",
      tracked_minutes: "Tracked time, minutes",
    },
    navigation: {
      home: "Home",
      more: "More",
      skip_to_content: "Skip to content",
    },
    project: {
      no_statuses: "No statuses yet.",
      statuses: "Statuses",
    },
    projects: {
      empty: "No projects yet.",
      from_deal: "From opportunity",
      load_error: "Could not load projects. Your filters have been kept.",
      split_out:
        "Task groups that have been split out. They have their own statuses and their own board.",
    },
    prospects: {
      aktivitet: "Activity",
      ansatte: "Employees",
      bad_kommune: "Invalid municipality no. (3–4 digits).",
      berik_dode:
        "%{n} are bankrupt or being wound up and should be cleaned out.",
      berik_feil: "Enrichment stopped.",
      berik_ferdig: "Enriched %{n} entities.",
      berik_hjelp:
        "Fetches municipality, employees, statutory purpose and activity. Run this before scanning websites. Without purpose and activity, web agencies and IT companies get scored as prospects instead of filtered out.",
      berik_ikke_funnet: "%{n} org. nos. not found in the register.",
      berik_kjorer: "Enriching … %{n}",
      berik_start: "Enrich now",
      berik_tittel:
        "%{n} entities are missing details from the Brønnøysund register",
      bulk_clear: "Clear selection",
      bulk_delvis: "%{ok} of %{n} updated",
      bulk_ok: "%{n} prospects updated",
      bulk_valgt: "%{n} selected",
      clear_filters: "Clear filters (%{n})",
      clear_follow_up: "Clear follow-up date",
      close_reason: "Reason for closing",
      close_reason_placeholder: "E.g. has a contract with another supplier",
      cold: "Cold",
      contact: "Contact",
      count_none: "No prospects",
      count_range: "Showing %{fra}–%{til} of %{n} · sorted by temperature",
      d_behov: "Need",
      d_evne: "Ability",
      d_ukjent: "unknown",
      deep_done: "Deep scanned",
      deepscan: "Deep scan",
      deepscan_blocked:
        "The website appears to belong to a different organization. Resolve the link first.",
      deepscan_title: "Lighthouse + WCAG via PageSpeed Insights",
      deepscanned: "Deep scan complete",
      delt_nettsted: "Shared website",
      delt_nettsted_hint:
        "Same website as %{navn}. At most one of them owns it. Confirm in the details panel.",
      dismiss: "Dismiss",
      empty: "No prospects yet. Use «New search».",
      f_kommune: "Municipality",
      f_naering: "Industry code",
      f_no_site: "Only without identified website",
      f_temp_v: "Temperature from %{n}",
      filter: "Filter",
      filter_nullstill_ett: "Clear %{n} selected",
      filter_sok: "Search …",
      filter_tomt: "No results",
      fit: "Fit",
      follow_up_date: "Follow-up date",
      followup: "Follow-up",
      formaal: "Statutory purpose",
      from_brreg: "From the Brønnøysund register",
      hot: "Hot",
      import_feil: "Could not read the file.",
      import_ferdig:
        "%{n} rows written. Source set on %{kilde}, web address on %{url}, founding date on %{dato} and VAT status on %{mva}.",
      import_gjenoppta: "Click «Write» again to continue where it stopped.",
      import_intro:
        "CSV from Proff Forvalt. The file is read in your browser. Nothing is written until you have seen the numbers and clicked «Write».",
      import_knapp: "Import file",
      import_kunder: "Filtered out as customer: %{navn}",
      import_leser: "Reading the file …",
      import_neste:
        "Next steps, in this order: «Enrich now» (fetches municipality, employees and purpose from the Brønnøysund register), then «Find websites», then «Scan websites». The order is not optional. Without enrichment, web agencies get scored as prospects.",
      import_skriv: "Write %{n} rows",
      import_skriver: "Writing … %{ferdig} of %{totalt}",
      import_til:
        "To load: %{n} rows. %{nye} new, %{gamle} update existing ones.",
      import_tittel: "Import Proff file",
      import_velg: "Choose CSV file",
      in_pipeline: "In pipeline",
      is_customer: "Already a customer. Open",
      jobb_feil: "The job stopped.",
      jobb_gjenoppta: "Click again to continue where it stopped.",
      jobb_mer:
        "The limit for one click has been reached. Click again for the rest.",
      jobb_skann: "Scan websites",
      jobb_skann_ferdig: "Tried %{f} rows, assessed %{n}.",
      jobb_skann_kjorer: "Scanning … %{n}",
      jobb_tom: "Nothing to do. All rows have been processed.",
      jobb_url: "Find websites",
      jobb_url_ferdig: "Tried %{f} rows, found a website for %{n}.",
      jobb_url_kjorer: "Finding websites … %{n}",
      kilde: "Source",
      kilde_ukjent: "Unknown",
      killed: "Excluded: web agency/competitor",
      kommune: "Municipality no.",
      lh_a11y: "A11y",
      lh_perf: "performance",
      lh_seo: "SEO",
      limit: "Max count",
      naering_hint: "Empty = all industries. Prefix matches (47 = all retail).",
      naeringskode: "Industry code (NACE)",
      naeringskoder: "Industry codes (comma-separated)",
      never_scanned: "Not scanned",
      new_search: "New search",
      no_owner: "No owner",
      no_signals: "No signals.",
      no_site: "No website identified",
      no_site_confirmed: "Confirmed without website",
      note: "Note",
      note_placeholder: "Write a note before reaching out …",
      omsetning: "Revenue",
      open_deal: "Open in Pipeline",
      owner: "Owner",
      pick: "Select a prospect to see details.",
      promote: "Convert to customer",
      promoted: "The prospect became a customer",
      report: {
        accessibility: "Accessibility",
        analyzed: "analyzed",
        back: "Back",
        company: "About the organization (Brønnøysund register)",
        findings: "Analysis findings",
        findings_sub: "in %{n} of %{total} areas",
        footer:
          "Basis: open data from the Brønnøysund register and an automated analysis of the organization's website. The findings are indicative and should be verified manually.",
        needs_deep: "Requires deep scan",
        no_findings: "No findings recorded. Run a scan from Prospecting first.",
        not_found: "Prospect not found.",
        performance: "Lighthouse performance",
        print: "Print / save as PDF",
        seo: "Technical SEO",
        title: "Digital presence assessment",
      },
      report_blocked:
        "Confirm that the website belongs to the organization before creating a report about it.",
      report_button: "Create report",
      report_title: "Printable report of the findings",
      restore: "Show again",
      run: "Fetch and analyze",
      run_error: "Something went wrong.",
      save_error: "Could not save",
      save_search: "Save this search",
      saved: "Search saved",
      scan_retry: "Reassess the websites",
      scan_retry_hint:
        "Also scans websites that have already been assessed. Use it after the assessment rules have changed. Otherwise they only apply to new websites.",
      search: "Search name, industry, activity …",
      search_desc:
        "Fetches companies, finds websites and scores them automatically.",
      search_name: "Search name",
      search_title: "Fetch prospects from Brønnøysund",
      select_row: "Select %{navn}",
      show_dismissed: "Dismissed (%{n})",
      sikkerhet: "Unverified website",
      status: "Status",
      step_brreg: "Brønnøysund: fetched %{f}, saved %{u} (filtered %{s})",
      step_done: "Done.",
      step_scan: "Scan: assessed %{n} of %{f}",
      step_scan_mer:
        "The limit for one run has been reached. Run again for the rest",
      step_urls: "Websites: tried %{f}, found %{n}",
      timing: "Timing",
      title: "Prospects",
      url_cand_answered: "The domain responded when we tried",
      url_cand_silent: "The domain did not respond",
      url_cand_untried: "Not tried. We stopped at a match before this one",
      url_candidates: "Other domains we considered:",
      url_clear: "Not their site",
      url_confirm: "Correct site",
      url_confirmed: "Confirmed",
      url_conflict: "The website appears to belong to a different organization",
      url_conflict_hint:
        "The page lists a different organization number, so the findings are not included in the score.",
      url_fix: "Fix the address",
      url_probable: "Probable",
      url_retry: "Search for websites again",
      url_retry_hint:
        "Includes entities we previously gave up on. Use it after the search method has been improved. Otherwise it just repeats the same work.",
      url_unverified: "The website is not confirmed",
      vakter_hint:
        "Filtered out: bankruptcy/winding-up and wrong municipality. Large companies and holding companies are included, but can be down-weighted in scoring (Settings → Prospecting).",
      vinnbarhet: "Winnability",
      why: "Why this prospect",
      wp: "WordPress",
      wp_core: "Core",
      wp_plugins: "%{n} plugins",
      wp_theme: "Theme",
    },
    reports: {
      actual_total: "Actual time",
      admin_only: "Reports are only available to admins.",
      all: "All",
      assignee: "Assignee",
      billable: "Billable",
      billable_rounded: "Billable quantity (%{unit} min)",
      billable_short: "bill.",
      by_customer: "By customer",
      by_user: "By user",
      clear: "Clear",
      cost: "Cost",
      csv: {
        amount: "Amount",
        cost: "Cost",
        date: "Date",
        hour_value: "Time value (current rate)",
        hours: "Hours",
        margin: "Margin",
        no: "No",
        note: "Note",
        task: "Task",
        user: "Person",
        yes: "Yes",
      },
      current_rates:
        "Calculated with current rates, not actual invoiced revenue. Hours without a rate are excluded, and margin is unknown where the rate is missing.",
      customer: "Customer",
      economy: {
        billable_hours: "Billable hours",
        empty:
          "No customers with tracked time, products or won opportunities yet.",
        help: "All tracked time per customer: time value (billable hours × hourly rate), cost (all hours × cost rate) and margin, plus recurring product revenue per month (MRR). Customers without activity are not shown.",
        mrr: "MRR",
        won_12m: "Won (12 mo.)",
      },
      empty: "No time tracked in this period.",
      export: "Export CSV",
      from: "From",
      hour_value: "Time value",
      last_month: "Last month",
      load_failed: "The report could not be loaded completely.",
      margin: "Margin",
      missing_cost_time: "%{duration} is missing a cost rate.",
      missing_rate_time:
        "%{duration} of billable time is missing an hourly rate.",
      n_selected: "%{smart_count} selected",
      no_customer: "No customer",
      no_project: "No project",
      non_billable: "Non-billable",
      project: "Project",
      sales: {
        by_month: "Won and lost per month",
        by_source: "By source",
        by_source_help:
          "«Prospecting» = opportunity created by «Convert to customer»; «Manual» = created in Pipeline.",
        by_stage: "Pipeline by stage",
        count: "Count",
        csv: {
          closed: "Closed",
          created: "Created",
          name: "Opportunity",
          source: "Source",
          stage: "Stage",
        },
        days_to_won: "Avg. days to won",
        help: "Pipeline, won/lost in the last 12 months and source split. Close date = last change on the opportunity.",
        loss_reason: "Reason",
        loss_reasons: "Why do we lose?",
        loss_reasons_help:
          "Lost opportunities in the last 12 months grouped by reason. «Unknown» = no reason recorded (set it on the opportunity card).",
        loss_unknown: "Unknown",
        lost: "Lost",
        lost_amount: "Lost amount",
        month: "Month",
        pipeline: "Pipeline value",
        pipeline_weighted: "Weighted pipeline value",
        source: "Source",
        source_manual: "Manual",
        source_prospect: "Prospecting",
        stage: "Stage",
        sum: "Sum",
        weighted: "Weighted",
        win_rate: "Win rate (12 mo.)",
        won: "Won",
        won_amount: "Won amount",
      },
      tab_customers: "Customers",
      tab_invoice_basis: "Invoice basis",
      tab_key_figures: "Key figures",
      tab_sales: "Sales",
      tab_time: "Time",
      this_month: "This month",
      this_week: "This week",
      title: "Reports",
      to: "To",
      total: "Total",
      unknown_margin: "Unknown margin",
      unknown_margin_help: "%{duration} is missing an hourly or cost rate",
    },
    sales: {
      title: "Pipeline",
    },
    settings: {
      account: {
        company_name_help:
          "The name of your own company. Used as the default name for «My company».",
      },
      billing: {
        help: "Hours are summed per customer, project and employee for the month and rounded up once per invoice line. Changes apply to new invoice bases; sent drafts keep the settings they were created with. Product lines use the product's own VAT.",
        hour_vat: "VAT on hours",
        journal_activate: "Activate the billing journal",
        journal_activated: "The billing journal is activated.",
        journal_active:
          "The billing journal was activated %{date} with first journal month %{month}. The start limit cannot be changed.",
        journal_confirm:
          "I have verified that recurring agreements before %{month} have already been invoiced.",
        journal_help:
          "From this month, Mimin keeps a journal of everything sent to Tripletex, and the same hour or agreement period cannot be sent twice. Agreement periods before this month count as invoiced. The choice cannot be changed after activation.",
        journal_month: "First journal month",
        journal_month_invalid: "Choose a month.",
        journal_title: "First journal month",
        load_failed: "Billing settings could not be loaded.",
        save: "Save billing settings",
        save_failed: "Could not save billing settings.",
        saved: "Billing settings saved. They apply to new invoice bases.",
        unit: "Billing unit (rounded up)",
        unit_hour: "Whole hour",
        unit_minutes: "%{minutes} minutes",
      },
      companies: {
        colors: "Colors",
        colors_help: "The colors a customer can be assigned.",
      },
      deals: {
        stages_probability_help:
          "The number is the probability (0–100 %) that an opportunity in this stage is won. It is used for the weighted pipeline value in the sales chart and the column totals.",
      },
      projects: {
        global_statuses: "Statuses for customer-level tasks",
        global_statuses_help:
          "One shared list for the whole instance. Changes here take effect immediately. These are the statuses actually used by tasks that sit directly on the customer.",
        statuses: "Project statuses",
        statuses_help:
          "Default statuses new projects start with. Statuses added here are also added to existing projects and the global list above. Renaming and deleting only apply to new projects.",
      },
      sections: {
        account: "Account",
        error_log: "Error log",
      },
    },
    shortcuts: {
      title: "Keyboard shortcuts",
    },
    time: {
      add: "Add",
      billable: "Billable",
      note: "Note",
      start: "Start timer",
      stop: "Stop timer",
      title: "Time",
      tracked: "Tracked",
      unsettled: "Unresolved",
      unsettled_hint:
        "The stop hasn't been confirmed by the server. Click to try again.",
    },
    timeline: {
      empty:
        "No events yet. Notes, email campaigns, opportunities, completed tasks and time entries show up here.",
      error: "Could not load the timeline.",
      more: "Show more",
      title: "Timeline",
    },
    tripletex_sync: {
      confirm: "Run sync",
      content:
        "Tripletex is the master for master data: names, customer numbers, addresses and prices are overwritten in Mimin. Notes, follow-ups and product links per customer are not touched.",
      menu: "Sync from Tripletex",
      preview_contact_counts:
        "%{matched} match, %{created} new, %{skipped} without email will be skipped.",
      preview_contacts: "Contacts",
      preview_customer_counts:
        "%{matched} match, %{created} will be created as new.",
      preview_customers: "Customers",
      preview_product_counts:
        "%{matched} match, %{created} new, %{deactivated} will be deactivated.",
      preview_products: "Products",
      preview_twin_hint:
        "Should any of these match an existing Mimin customer? Set the customer number on the Mimin customer and check again. Otherwise they are created as new cards.",
      recheck: "Check again",
      syncing: "Syncing …",
      title: "Sync from Tripletex",
    },
    views: {
      all: "All",
      create_help: "Saves the current filters, sorting and column layout.",
      create_title: "Save view",
      delete: "Delete view …",
      delete_help:
        "«%{name}» will be deleted for everyone it is shared with. This cannot be undone.",
      delete_title: "Delete view",
      dirty: "Modified",
      mine: "My views",
      name_label: "View name",
      name_placeholder: "E.g. «Customers without follow-up»",
      rename: "Rename …",
      rename_title: "Rename",
      save_new: "Save as new view …",
      share: "Share with team",
      team: "Shared with team",
      unshare: "Make private",
      update: "Update «%{name}»",
    },
    work_items: {
      bulk: {
        assigned: "Assignee set on %{smart_count} tasks",
        complete: "Complete",
        completed: "%{smart_count} tasks completed",
        due_set: "Due date set on %{smart_count} tasks",
        mixed_scope:
          "The statuses belong to different projects. Select tasks from one and the same place.",
        priority_set: "Priority set on %{smart_count} tasks",
        status_set: "Status set on %{smart_count} tasks",
      },
      load_error: "Could not load tasks. Your filters have been kept.",
      mine: "My tasks",
      reset_default: "Default view",
    },
  },
  ra: {
    action: {
      clear_search: "Clear search",
      move: "Move",
    },
  },
  "ra-supabase": {
    auth: {
      forgot_password: "Forgot password?",
      missing_tokens: "Access and refresh tokens are missing",
    },
    reset_password: {
      forgot_password: "Forgot password?",
      forgot_password_details:
        "Enter your email to receive a reset password link.",
    },
    set_password: {
      new_password: "Choose your password",
    },
  },
};
